<template>
  <div class="nav">

    <div class="desktop">
      <img id="serene_logo" src="@/assets/images/logos/serene_logo.png" />

      <ul>
        <li>
          <router-link to="/"> HOME </router-link>
        </li>
        <li>
          <router-link to="/about"> ABOUT </router-link>
        </li>
        <li>
          <router-link to="/products"> PRODUCTS </router-link>
        </li>
        <li>
          <router-link to="/salon"> SALON </router-link>
        </li>
      </ul>
    </div>

    <div class="wrapper mobile" :key="$route.path">
      <template v-if="isOpen">
        <div class="burgers openBurger">
          <label for="burgerCheck" class="burger" @click="toggleOpen"></label>
          <div class="navigation">
            <ul>
              <li>
                <router-link to="/"> HOME </router-link>
              </li>
              <li>
                <router-link to="/about"> ABOUT </router-link>
              </li>
              <li>
                <router-link to="/products"> PRODUCTS </router-link>
              </li>
              <li>
                <router-link to="/salon"> SALON </router-link>
              </li>
            </ul>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="burgers">
          <label for="burgerCheck" class="burger" @click="toggleOpen"></label>
          <div class="navigation">
            <ul>
              <li>
                <router-link to="/"> HOME </router-link>
              </li>
              <li>
                <router-link to="/about"> ABOUT </router-link>
              </li>
              <li>
                <router-link to="/products"> PRODUCTS </router-link>
              </li>
              <li>
                <router-link to="/salon"> SALON </router-link>
              </li>
            </ul>
          </div>
        </div>
      </template>

      <img id="serene_logo" src="@/assets/images/logos/serene_logo.png" />

    </div>

  </div>
</template>

<script>
import Styles from "./styles.scss";

export default {
  name: "Navbar",
  data() {
    return {
      Styles,
      isOpen: false
    };
  },
  methods: {
    toggleOpen(){
      this.isOpen = !this.isOpen;
    }
  }, 
  watch: {
    $route() {
      this.isOpen = false;
    },
  },
};
</script>
